(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.mobileStickyQuery = window.matchMedia('(max-width: 989px)');
      this.desktopAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      /* Mobile fixed-header placeholder.
         On the transparent homepage header we intentionally keep the overlay
         behaviour, so no placeholder is activated there. */
      this.mobilePlaceholder = document.createElement('div');
      this.mobilePlaceholder.className = 'mobile-header-placeholder';
      this.mobilePlaceholder.setAttribute('aria-hidden', 'true');
      this.header.parentNode.insertBefore(this.mobilePlaceholder, this.header);

      this.isTransparentHomeHeader = this.classList.contains('header-wrapper--transparent-home');

      this.measureMobileHeaderStart = () => {
        if (!this.mobileStickyQuery.matches) return;

        const wasFixed = this.header.classList.contains('mobile-header-fixed');

        if (wasFixed) {
          this.header.classList.remove('mobile-header-fixed');
          this.mobilePlaceholder.classList.remove('is-active');
        }

        this.mobileHeaderStart =
          this.header.getBoundingClientRect().top +
          (window.pageYOffset || document.documentElement.scrollTop);

        if (wasFixed) {
          this.updateMobileFixedState();
        }
      };

      requestAnimationFrame(() => {
        this.setHeaderHeight();
        this.measureMobileHeaderStart();
        this.updateMobileFixedState();
      });

      this.onResizeHandler = () => {
        this.setHeaderHeight();

        if (this.mobileStickyQuery.matches) {
          this.measureMobileHeaderStart();
          this.updateMobileFixedState();
        } else {
          this.header.classList.remove('mobile-header-fixed');
          this.mobilePlaceholder.classList.remove('is-active');
        }
      };

      window.addEventListener('resize', this.onResizeHandler);

      this.mobileStickyQuery.addEventListener('change', () => {
        this.setHeaderHeight();

        if (this.mobileStickyQuery.matches) {
          requestAnimationFrame(() => {
            this.measureMobileHeaderStart();
            this.updateMobileFixedState();
          });
        } else {
          this.header.classList.remove('mobile-header-fixed');
          this.mobilePlaceholder.classList.remove('is-active');
        }
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    updateMobileFixedState() {
      if (!this.mobileStickyQuery || !this.mobileStickyQuery.matches || !this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const start = Number.isFinite(this.mobileHeaderStart) ? this.mobileHeaderStart : 0;
      const shouldFix = scrollTop >= start;

      if (shouldFix) {
        this.header.classList.add('mobile-header-fixed', 'shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');

        if (!this.isTransparentHomeHeader) {
          this.mobilePlaceholder.classList.add('is-active');
        }
      } else {
        this.header.classList.remove(
          'mobile-header-fixed',
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
        this.mobilePlaceholder.classList.remove('is-active');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);

      if (this.mobilePlaceholder) {
        this.mobilePlaceholder.remove();
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observerInstance) => {
        this.headerBounds = entries[0].intersectionRect;
        observerInstance.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* Mobile: fixed-on-scroll implementation.
         Do not let Dawn's hide/reveal behaviour run here. */
      if (this.mobileStickyQuery && this.mobileStickyQuery.matches) {
        this.updateMobileFixedState();
        this.currentScrollTop = scrollTop;
        return;
      }

      const headerIsAlwaysSticky = this.desktopAlwaysSticky;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(() => {
          if (!headerIsAlwaysSticky) this.hide();
        });
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(() => {
            if (!headerIsAlwaysSticky) this.reveal();
          });
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(() => {
            if (!headerIsAlwaysSticky) this.hide();
          });
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(() => {
          if (!headerIsAlwaysSticky) this.reset();
        });
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.desktopAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.desktopAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.desktopAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
